import {
    getFocusList,
    getFansList
} from '@/api/user';
import {
    passport
} from "@/api/common";
export default {
    namespaced: true,
    state: () => ({
        fansNum: 0,
        focusNum: 0,
        fansList: [],
        focusList: [],
        message: {}
    }),
    mutations: {
        setFansNum(state, num) {
            state.fansNum = num;
        },
        setfansList(state, obj) {
            state.fansList = obj;
        },
        setFocusNum(state, num) {
            state.focusNum = num;
        },
        setFocusList(state, obj) {
            state.focusList = obj;
        },
        messageInfo(state, obj) {
            state.message = obj;
        }
    },
    actions: {
        async fetchData({
            commit
        }) {
            try {
                // 获取关注列表总数
                const focusRes = await getFocusList({
                    q: '',
                    page: 1,
                    size: 10
                });
                if (focusRes.errno === 0) {
                    commit('setFocusNum', focusRes.data.total);
                    commit('setFocusList', focusRes.data.list);
                } else {
                    console.error(`Error fetching focus total: ${focusRes.errmsg}`);
                }
                // 获取粉丝列表总数
                const fansRes = await getFansList({
                    page: 1,
                    size: 10
                });
                if (fansRes.errno === 0) {
                    commit('setFansNum', fansRes.data.total);
                    commit('setfansList', fansRes.data.list);
                } else {
                    console.error(`Error fetching fans total: ${fansRes.errmsg}`);
                }
            } catch (error) {
                console.error(`Unexpected error fetching data: ${error}`);
            }
        },
        // 获取用户信息
        async GetMessage({
            commit
        }) {
            try {
                const res = await passport();
                if (res) {
                    commit('messageInfo', res.data);
                } else {
                    console.log(res.errmsg);
                }
            } catch (error) {
                throw error;
            }
        }
    },
}